import React from 'react';

interface RelationSelectorProps {
  label: string;
  selectedIds: number[];
  options: Array<{ id: number; name: string }>;
  onChange: (ids: number[]) => void;
  errors?: string[];
  columns?: number;
  showSelectAll?: boolean; // 全て選択/解除ボタンを表示するか
}

const RelationSelector: React.FC<RelationSelectorProps> = ({
  label,
  selectedIds,
  options,
  onChange,
  errors,
  columns = 3,
  showSelectAll = true,
}) => {
  const handleChange = (id: number, checked: boolean) => {
    if (checked) {
      onChange([...selectedIds, id]);
    } else {
      onChange(selectedIds.filter((selectedId) => selectedId !== id));
    }
  };

  const handleSelectAll = () => {
    const allIds = options.map((option) => option.id);
    onChange(allIds);
  };

  const handleClearAll = () => {
    onChange([]);
  };

  const allSelected = options.length > 0 && options.every((option) => selectedIds.includes(option.id));

  const colClass = `col-md-${12 / columns}`;

  return (
    <div className="form-group">
      <div className="d-flex justify-content-between align-items-center mb-2">
        {label && (
          <label className="form-label fw-semibold mb-0">{label}</label>
        )}
        {showSelectAll && options.length > 0 && (
          <div className="d-flex gap-2">
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={handleSelectAll}
              disabled={allSelected}
            >
              全て選択
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={handleClearAll}
              disabled={selectedIds.length === 0}
            >
              全て解除
            </button>
            <span className="text-muted small align-self-center">
              {selectedIds.length}/{options.length}件選択中
            </span>
          </div>
        )}
      </div>
      <div className="row">
        {options.map((option) => (
          <div key={option.id} className={`${colClass} mb-2`}>
            <div className="form-check">
              <input
                className={`form-check-input ${errors ? 'is-invalid' : ''}`}
                type="checkbox"
                id={`relation_${option.id}`}
                checked={selectedIds.includes(option.id)}
                onChange={(e) => handleChange(option.id, e.target.checked)}
              />
              <label className="form-check-label" htmlFor={`relation_${option.id}`}>
                {option.name}
              </label>
            </div>
          </div>
        ))}
      </div>
      {errors && errors.length > 0 && (
        <div className="invalid-feedback d-block">{errors.join(', ')}</div>
      )}
    </div>
  );
};

export default RelationSelector;

